import React, { Dispatch, SetStateAction } from 'react'
import Tick from 'public/icons/tick-square.svg'

interface CheckboxProps {
  isToggled: boolean
  toggle: Dispatch<SetStateAction<boolean>>
}

const Checkbox = ({ isToggled, toggle }: CheckboxProps) => {
  return (
    <div
      className="h-[20px] w-[20px] cursor-pointer rounded-md border-none bg-th-input-border"
      onClick={() => toggle(!isToggled)}
    >
      {isToggled && <Tick />}
    </div>
  )
}

export default Checkbox
